import { Link } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const content = {
  'zh-TW': { title: '找不到頁面', desc: '你要找的頁面不存在或已被移動。', btn: '返回首頁' },
  'zh-CN': { title: '找不到页面', desc: '你要找的页面不存在或已被移动。', btn: '返回首页' },
  en: { title: 'Page Not Found', desc: 'The page you are looking for does not exist or has been moved.', btn: 'Back to Home' },
};

export default function NotFoundPage() {
  const { lang } = useLanguage();
  const c = content[lang] || content.en;
  return (
    <div data-testid="not-found-page" className="pt-20 bg-[#080B10] min-h-[70vh] flex items-center justify-center">
      <div className="text-center px-6">
        <p className="text-7xl md:text-8xl font-bold text-[#6366F1] tracking-tighter mb-6" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          404
        </p>
        <h1 className="text-2xl md:text-3xl font-bold text-[#F8FAFC] mb-3" style={{ fontFamily: "'Plus Jakarta Sans', 'Noto Sans TC', sans-serif" }}>
          {c.title}
        </h1>
        <p className="text-sm md:text-base text-[#94A3B8] mb-8" style={{ fontFamily: "'Manrope', 'Noto Sans TC', sans-serif" }}>
          {c.desc}
        </p>
        <Link to="/">
          <Button data-testid="not-found-home-button" className="h-11 px-7 rounded-full bg-[#6366F1] text-white font-bold text-sm hover:bg-white hover:text-[#080B10] transition-all">
            <ArrowLeft className="mr-2 h-4 w-4" />
            {c.btn}
          </Button>
        </Link>
      </div>
    </div>
  );
}
